import { Link } from 'react-router-dom';
import NewsletterSignup from '../NewsletterSignup/NewsletterSignup';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer__main container">
        <div className="footer__grid">
          <div className="footer__col">
            <h3 className="footer__heading">Contact Us</h3>
            <address className="footer__address">
              <p>1234 Culinary Ave, Suite 100</p>
              <p>Washington, DC 20002</p>
              <p>
                <a href="tel:+12025554567">(202) 555-4567</a>
              </p>
            </address>
          </div>

          <div className="footer__col">
            <h3 className="footer__heading">Hours</h3>
            <div className="footer__hours">
              <p><span>Monday - Saturday</span><span>5:00 PM - 11:00 PM</span></p>
              <p><span>Sunday</span><span>5:00 PM - 9:00 PM</span></p>
            </div>
          </div>

          <div className="footer__col">
            <NewsletterSignup />
          </div>
        </div>
      </div>

      <div className="footer__bottom">
        <div className="container">
          <div className="footer__bottom-content">
            <p>&copy; {new Date().getFullYear()} Cafe Fausse. All rights reserved.</p>
            <nav className="footer__nav">
              <Link to="/">Home</Link>
              <Link to="/menu">Menu</Link>
              <Link to="/reservations">Reservations</Link>
              <Link to="/about">About</Link>
              <Link to="/gallery">Gallery</Link>
            </nav>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
